window.initProjectButtonsDropdowns = function initProjectButtonsDropdowns() {
  const projectButtonsDropdownsWrArr = document.querySelectorAll(
    '.project-dropdown-btn-wr'
  );

  if (projectButtonsDropdownsWrArr.length) {
    projectButtonsDropdownsWrArr.forEach((projectButtonsDropdownWr) => {
      if (!projectButtonsDropdownWr.classList.contains('is-init')) {
        projectButtonsDropdownWr.classList.add('is-init');

        const btn = projectButtonsDropdownWr.querySelector(
          '.btn'
        );
        const content = projectButtonsDropdownWr.querySelector(
          '.project-dropdown-btn-content'
        );
        const contentItemsArr = content.querySelectorAll(
          '.project-dropdown-btn-content__link'
        );
        const placeholder = projectButtonsDropdownWr.querySelector(
          '.project-dropdown-placeholder'
        );

        if (placeholder) {
          checkedSelectedItems();
        }

        function checkedSelectedItems() {
          contentItemsArr.forEach((item) => {
            if (item.classList.contains('is-selected')) {
              const flag = item.querySelector(
                '.project-dropdown-btn-content__link-flag'
              );

              placeholder.textContent = item.textContent;

              if (item.querySelector('.amd-value-to-label')) {
                placeholder.textContent = item.querySelector(
                  '.amd-value-to-label'
                ).textContent;
              }

              if (placeholder.classList.contains('if-language')) {
                const flagClone = flag.cloneNode(true);
                placeholder.innerHTML = '';
                placeholder.appendChild(flagClone);
              }
            }
          });
        }

        document.body.appendChild(content);
        content.style.position = 'absolute';

        btn.addEventListener('click', (e) => {
          e.preventDefault();

          if (!content.classList.contains('is-open')) {
            function contentPositionFunc() {
              content.style.minWidth = btn.clientWidth + 'px';
              const btnRect = btn.getBoundingClientRect();
              const contentRect = content.getBoundingClientRect();
              const viewportWidth = window.innerWidth;
              const viewportHeight = window.innerHeight;
              const scrollTop =
                window.scrollY || document.documentElement.scrollTop;

              let top = btnRect.bottom + scrollTop;
              let left = btnRect.right - contentRect.width;

              if (left < 0) left = btnRect.left;

              /*if (top + contentRect.height > viewportHeight + scrollTop) {
                top = btnRect.top - contentRect.height + scrollTop;
              }*/

              if (content.classList.contains('if-bottom-position')) {
                top = btnRect.top + scrollTop;
                content.style.top = `${top + btn.clientHeight + 4}px`;
              } else {
                content.style.top = `${top - btn.clientHeight - 4}px`;
              }

              if (content.classList.contains('if-left-position')) {
                left = btnRect.left;
              }

              content.style.left = `${left}px`;
            }
            contentPositionFunc();
            content.classList.add('is-open');
            projectButtonsDropdownWr.classList.add('is-open');
            setTimeout(() => {
              contentPositionFunc();
            }, 0);
          } else {
            content.classList.remove('is-open');
            projectButtonsDropdownWr.classList.remove('is-open');
          }
        });

        document.addEventListener('click', (e) => {
          if (!content.contains(e.target) && !btn.contains(e.target)) {
            content.classList.remove('is-open');
            projectButtonsDropdownWr.classList.remove('is-open');
          }
        });

        function hideDropdown() {
          content.classList.remove('is-open');
          projectButtonsDropdownWr.classList.remove('is-open');
        }

        if (content.classList.contains('if-hidden-on-scroll')) {
          document.addEventListener('scroll', () => {
            hideDropdown();
          });

          document.addEventListener('touchmove', () => {
            hideDropdown();
          });
        }

        const scrollContainer = projectButtonsDropdownWr.closest(
          '.project-container-scroll'
        );
        if (scrollContainer) {
          scrollContainer.addEventListener('scroll', hideDropdown);
          scrollContainer.addEventListener('touchmove', hideDropdown);
        }

        if (content.querySelector('.is-selected')) {
          contentItemsArr.forEach((item) => {
            item.addEventListener('click', (e) => {
              if (item.tagName === 'A' || item.tagName === 'BUTTON') {
                e.preventDefault();
              }

              for (let i = 0; i < contentItemsArr.length; i++) {
                contentItemsArr[i].classList.remove('is-selected');
              }
              item.classList.add('is-selected');

              if (placeholder) {
                checkedSelectedItems();
              }

              if (item.classList.contains('if-open-amd-inline')) {
                if (!item.classList.contains('is-open-amd-inline')) {
                  item.classList.add('is-open-amd-inline');
                }
              }
            });

            if (item.classList.contains('if-open-amd-inline')) {
              const adpClose = item.querySelector(
                '.project-dropdown-btn-content__link-calendar-close'
              );
              setInterval(function () {
                if (item.classList.contains('is-open-amd-inline')) {
                  checkedSelectedItems();
                }
              }, 300);

              adpClose.addEventListener('click', (e) => {
                setTimeout(function () {
                  item.classList.remove('is-open-amd-inline');
                }, 50);
              });
            }
          });
        }
      }
    });
  }
};

initProjectButtonsDropdowns();
